module.exports = __webpack_public_path__ + "static/media/call-action-bg.1a5496fb.jpg";